import { s3 } from "./AwsS3";

type Props = {
  file: any;
  userId?: string;
  folderName: string;
  caseId?: string;
  inmateName?: string;
};

/**
 * Uploads an image to AWS S3.
 * @component uploadImageToS3
 * @author Sanjay
 *
 */

// export const uploadImageToS3 = async ({ file, userId, folderName }: Props) => {
//   const params = {
//     Bucket: `${process.env.REACT_APP_AWS_BUCKET_NAME}/${folderName}`,
//     Key: `${userId}/${file.name}`,
//     ContentType: file.type,
//     Body: file,
//   };

//   try {
//     const data = await s3.upload(params).promise();
//     return data;
//   } catch (err: any) {
//     throw new Error(`Upload failed: ${err.message}`);
//   }
// };

//Here
export const uploadImageToS3 = async ({
  file,
  userId,
  caseId,
  inmateName,
  folderName,
}: any) => {
  const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;

  if (!bucketName) {
    throw new Error("AWS Bucket name is not defined in environment variables.");
  }

  const params = {
    Bucket: bucketName, // Now we are sure it's a string
    Key: caseId
      ? `Cases/${inmateName}-${caseId}/${folderName}/${file.name}`
      : `${folderName}/${userId}/${file.name}`,
    ContentType: file.type,
    Body: file,
  };

  try {
    const data = await s3.upload(params).promise();
    // const destinationKey = `Cases/${inmateName}-${caseId}/Local Documents/${file.name}`;
    // const uploadDocumentParams = {
    //   Bucket: bucketName,
    //   CopySource: `Cases/${inmateName}-${caseId}/${folderName}/${file.name}`,
    //   Key: destinationKey,
    // };
    // const uploadDocumentParams = {
    //   Bucket: bucketName, // Now we are sure it's a string
    //   Key: caseId ? destinationKey : `${folderName}/${userId}/${file.name}`,
    //   ContentType: file.type,
    //   Body: file,
    // };

    // if (folderName === "Chat Documents" || folderName === "Uploaded Documents")
    // Copy within S3
    // await s3.copyObject(uploadDocumentParams).promise();
    // await s3.upload(uploadDocumentParams).promise();

    return data;
  } catch (err: any) {
    throw new Error(`Upload failed: ${err.message}`);
  }
};

// export const uploadImageToS3 = ({ file, userId, folderName }: Props) => {
//   const params = {
//     Bucket: `coxlaw/${folderName}`,
//     Key: `${userId}/${file.name}`,
//     ContentType: file.type,
//     Body: file,
//   };

//   return new Promise((resolve, reject) => {
//     s3.upload(params, (err: any, data: any) => {
//       if (err) {
//         reject(err);
//       } else {
//         resolve(data);
//       }
//     });
//   });
// };
